/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_3_DescInputs */

const en_mk_feature_3_desc = /** @type {(inputs: Mk_Feature_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owners, comments, activity, and notifications with daily digests based on your settings.`)
};

const id_mk_feature_3_desc = /** @type {(inputs: Mk_Feature_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penanggung jawab, komentar, aktivitas, serta pemberitahuan dan ringkasan harian sesuai pengaturan.`)
};

/**
* | output |
* | --- |
* | "Owners, comments, activity, and notifications with daily digests based on your settings." |
*
* @param {Mk_Feature_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_3_desc = /** @type {((inputs?: Mk_Feature_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_3_desc(inputs)
	return en_mk_feature_3_desc(inputs)
});